import React from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';

const LoadingSpinner = ({ loading }) => {
  if (!loading) return null;

  return (
    <Fade in={loading}>
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: 1000,
          background: '#FFFFFF',
          borderRadius: '6px',
          p: 1.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          border: '1px solid #E5E5E5',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          minWidth: 48,
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          size={20}
          thickness={5}
          sx={{
            color: '#4698D3',
          }}
        />
      </Box>
    </Fade>
  );
};

export default LoadingSpinner;